import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactSlidingPane from '../../components/ReactSlidingPane';
import { useQuery } from 'react-query';
import FuzzySearch from 'fuzzy-search';
import { chrApi } from '../../api/api';
import { usePracticeProviderContext } from '../../context/PracticeProviderContext';
import FormCheck from 'react-bootstrap/FormCheck';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import { FilterComponent } from '../SecureShare/ExternalContactTable';

function useEmployers(practiceId) {
  return useQuery(['fetchEmployers', practiceId], () => chrApi('get', `employer/practice/${practiceId}`, null, null).then((res) => res.data), { enabled: !!practiceId });
}

// TODO: Search Filter for Employer Lookup

function EmployerLookupPane(props) {
  const { practice } = usePracticeProviderContext();
  const [filterText, setFilterText] = React.useState('');
  const [selectedEmployer, setSelectedEmployer] = useState({});
  const { isOpen, onClose, onSelect } = props;

  useEffect(() => {
    if (!isOpen) {
      setSelectedEmployer({});
    }
  }, [isOpen]);

  const { data = [] } = useEmployers(practice);
  const searcher = new FuzzySearch(data, ['name', 'street', 'city']);
  const filteredEmployers = searcher.search(filterText);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setFilterText('');
      }
    };

    return <FilterComponent onFilter={(e) => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} placeholder={'Filter by name, street & city'} />;
  }, [filterText]);
  return (
    <ReactSlidingPane onClose={onClose} state={isOpen} title={'Employer'}>
      <p className={'h5'}>Employers</p>
      {subHeaderComponentMemo}
      <div style={{ height: '80vh', overflowY: 'scroll' }}>
        {filteredEmployers.map((emp) => {
          const { name, address = {}, id: empId } = emp;
          const { street = '', city = '' } = address;
          return (
            <FormCheck
              className={'my-2'}
              key={empId}
              type={'radio'}
              label={`${name} (${street} ${city ? ', ' + city : ''})`}
              checked={selectedEmployer?.id === empId}
              onChange={() => setSelectedEmployer(emp)}
            />
          );
        })}
      </div>
      <Row className={'fixed-bottom m-2'}>
        <Col>
          <Button
            disabled={data.length === 0}
            size={'sm'}
            onClick={() => {
              onSelect(selectedEmployer);
              onClose();
            }}
            className={'mr-2 px-4'}
            variant={'primary'}
          >
            Select
          </Button>
          <Button onClick={onClose} size={'sm'} className={'px-4'} variant={'fff'}>
            Cancel
          </Button>
        </Col>
      </Row>
    </ReactSlidingPane>
  );
}

EmployerLookupPane.propTypes = {};
EmployerLookupPane.defaultProps = {};

export default EmployerLookupPane;
